import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import admin from 'firebase-admin';

import React, { useState } from 'react';

import StandardInputComponent from '../form-elements/standard-input';
import SubmitButton from '../form-elements/submit-button';

import { baseTheme } from '../../theme';
import { emailSupport } from '../../services/mail';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
      paddingBottom:theme.spacing(5),
    },
    headerSpacing: {
      marginBottom: theme.spacing(1),
    },
    inputBase: {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.primary.main,
      width: '100%',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      borderRadius: '5px',
    },
    contentRoot: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    inputRoot: {
      marginBottom: theme.spacing(1),
      paddingRight: theme.spacing(2),
      position: 'relative',

    },
    buttonContainer: {
      width: '10%',
      position: 'absolute',
      right: theme.spacing(2),
    },
    submitButton: {
      fontSize: '1em',
    },
    input: {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.primary.main,
    },
    label: {
      color: theme.palette.primary.main,
    },
    upperRow: {
      flexDirection: 'row',
    },
    textContainer: {
      flexDirection: 'column',
    },
    iconContainer: {
      flexDirection: 'column',
      alignItems: 'flex-end',
    },
    askMeIcon: {
      marginTop: theme.spacing(-6),
      height: '10em',
      width: '10em',
    },
  }),
);

export default function SupportFormComponent(props: any) {
  const classes = useStyles(baseTheme);
  const defaultFormValues = {
    username: '',
    email: '',
    comments: '',
  };
  const [formValues, setFormValues] = useState(defaultFormValues);
  const [supportEmailSent, setSupportEmailSent] = useState(false);

  const handleChange = (prop: any) => (event: any) => {
    setFormValues({ ...formValues, [prop]: event.target.value });
  };

  const handleSubmit = () => {
    return emailSupport(formValues)
        .then(() => {
          setSupportEmailSent(true);
        });
  };
  if (supportEmailSent) {
    return (
          <Grid container item className={classes.root}>
              <Grid item xs={12} className={classes.contentRoot}>
                  <Typography variant="h5" color="primary" className={classes.headerSpacing}>
                      Support
                  </Typography>
                  We welcome and encourage all comments, questions and suggestions about Reliht.
                  We do our best to respond to all inquiries as soon as possible. Please allow up
                  to two business days for a response, thank you.
                  <Typography variant="h5" color="primary" className={classes.headerSpacing}>
                      Support Email Sent
                  </Typography>
              </Grid>
          </Grid>
    );
  }
  return (
    <Grid container item className={classes.root}>
      <Grid item xs={12} className={classes.contentRoot}>
        <Grid container item xs={12} className={classes.upperRow}>
          <Grid container item xs={10} className={classes.textContainer}>
              <Typography variant="h5" color="primary" className={classes.headerSpacing}>
                Support
              </Typography>
              We welcome and encourage all comments, questions and suggestions about Reliht.
              We do our best to respond to all inquiries as soon as possible. Please allow up
              to two business days for a response, thank you.
            </Grid>
            <Grid container item xs={2} className={classes.iconContainer}>
              <img
                src="/images/ask_me.png"
                alt="Ask Me Icon"
                className={classes.askMeIcon}/>
            </Grid>
          </Grid>
        </Grid>
      <Grid item xs={12} md={6} className={classes.inputRoot}>
        <FormControl variant="filled" className={classes.inputBase}>
          <StandardInputComponent
            id="username"
            label="UserName"
            value={formValues.username}
            onChange={handleChange('username')}
          />
        </FormControl>
      </Grid>

      <Grid item xs={12} md={6} className={classes.inputRoot}>
        <FormControl variant="filled" className={classes.inputBase}>
          <StandardInputComponent
            id="email"
            label="Email"
            value={formValues.email}
            onChange={handleChange('email')}
          />
        </FormControl>
      </Grid>

      <Grid item xs={12} className={classes.inputRoot}>
        <FormControl variant="filled" className={classes.inputBase}>
          <TextField
            id="filled-comments"
            variant="filled"
            label="Comments, questions and suggestions about Reliht."
            multiline
            rowsMax={10}
            rows={10}
            value={formValues.comments}
            onChange={handleChange('comments')}
          />
        </FormControl>
      </Grid>

      <Grid item xs={12} className={classes.inputRoot}>
        <div className={classes.buttonContainer}>
          <SubmitButton
            className={classes.submitButton}
            onClick={handleSubmit}
            text="Submit"
            variant="dark"
          />
        </div>
      </Grid>
    </Grid>
  );
}
